import React, {
  FunctionComponent,
  memo,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Justify } from 'tea-component';
import SearchRecent from '@/pages/intelligence/components/SearchRecent';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import { TOP_COMPANIES_NUM } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import { useDeepCompareEffect, useMemoizedFn, useSetState } from 'ahooks';
import { isEmpty, omit, uniq, get } from 'lodash-es';
import { useIntl, history } from 'umi';
import { useStreamingKolSearch } from '../../../Kol/hooks';
import {
  formattingGameSearchList,
  handleTableDefaultSelectGames,
} from '../../../Kol/utils';
import Tables from '../../../Kol/details/components/Tables';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import { usePcTopchartsStreamingRankList } from '../../hooks';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { ObjectOfStringValue } from '@/pages/intelligence/pages/GlobalView/MarketSize/hooks/useQuery';

interface StreamingGamesTableListProps<F = (...args: any[]) => void> {
  paramsDefault: ObjectOfStringValue;
  userIds: ObjectOfStringValue;
  setUserIds: F;
  intableRef: any;
  subTab: string;
  setParamsDefault: F;
  setTimeConfig: F;
  timeConfig: any;
  setTableLoading: F;
  [key: string]: unknown;
}
const StreamingGamesTableList: FunctionComponent<
StreamingGamesTableListProps
> = ({
  paramsDefault,
  setUserIds,
  intableRef,
  subTab,
  timeConfig,
  setParamsDefault,
  setTableLoading,
  setTimeConfig,
}) => {
  // 排序，公共组件匹配不到sort对应的key，额外新建一个ref来存储
  const sort = useRef({
    order_metric: 'hoursWatched',
    order: 0,
  });
  // 表格参数
  const [kolRankListProps, setKolRankListProps] = useSetState<{
    [key in string]: unknown;
  }>({
    order_metric: 'hoursWatched',
    order: 'desc',
  });
  // 是否需要更新图表数据
  const ecahrtsIsRefresh = useRef<boolean>(false);
  // 获取表格数据主要通过这2个接口途径
  const getDefauletStreamingList = useRef<'defaulet' | 'gameSearchIng'>(
    'defaulet',
  );
  // 表格数据
  const {
    data,
    loading: tableLoading,
    error,
    mutate,
  } = usePcTopchartsStreamingRankList(
    useMemo(
      () => ({
        ...kolRankListProps,
        ...omit(paramsDefault, ['page', 'page_size']),
        ...timeConfig,
      }),
      [kolRankListProps, paramsDefault],
    ),
    getDefauletStreamingList.current,
  );
  // 表格搜索接口数据
  const { runAsync } = useStreamingKolSearch('games');
  // 存储最新的动态勾选值
  const [tableSelectionNews, setTableSelection] = useState([]);
  // 存储第一次全选
  const [tableSelectionAll, setTableSelectionAll] = useState([]);
  // 缓存第一次的全选默认值
  const tableSelectionAllOneRefs = useRef<any>([]);
  // 存储多选checkStatus状态标识
  const [operatedGame, setOperatedGame] = useState('');
  // 中英切换方法
  const { formatMessage } = useIntl();
  const [imgActive, setImgActive] = useState('');
  const dataTable = data?.GamesRank || data?.game_data;
  // 当未查询到数据时，或者其他异常情况，清空,如果报错，将会重新请求3次，可以使用上一次的请求状态，缓存起来，进行回滚，重新拉取最新的数据，目前先设置为空数组把
  useEffect(() => {
    if (error) {
      // domesomething
      mutate([]);
    }
    if (tableLoading) {
      mutate([]);
    } else {
      ecahrtsIsRefresh.current = false;
      setOperatedGame('');
    }
  }, [error, tableLoading]);

  useEffect(() => {
    setTableLoading(tableLoading);
  }, [tableLoading]);

  useDeepCompareEffect(() => {
    if (operatedGame && operatedGame === 'cancel') return;
    if (operatedGame === 'clearAll') {
      const defaulet6Length = handleTableDefaultSelectGames(
        dataTable?.slice(0, TOP_COMPANIES_NUM),
      );
      setTableSelection(defaulet6Length);
      return;
    }
    if (operatedGame === 'defauletAll') {
      setTableSelection(tableSelectionNews);
      return;
    }
    if (
      isEmpty(tableSelectionNews) &&
      isEmpty(tableSelectionAllOneRefs.current)
    ) {
      const defaulet6Length = handleTableDefaultSelectGames(
        dataTable?.slice(0, TOP_COMPANIES_NUM),
      );
      tableSelectionAllOneRefs.current = defaulet6Length;
      setTableSelectionAll(defaulet6Length);
    }
  }, [
    dataTable,
    tableSelectionNews,
    setTableSelectionAll,
    paramsDefault,
    operatedGame,
  ]);
  // 每当公共参数变化的时候，直接重置，默认全选项为最新的数据
  useEffect(() => {
    tableSelectionAllOneRefs.current = '';
  }, [paramsDefault]);

  useImperativeHandle(
    intableRef,
    () => ({
      data: list,
      loading: tableLoading,
      dateTimes: [data?.start_data_time, data?.end_data_time],
      ecahrtsIsRefresh: () => {
        handleClearSearch();
      },
    }),

    [tableSelectionNews, dataTable, paramsDefault, tableSelectionAll],
  );
  const list = useMemo(() => {
    if (ecahrtsIsRefresh.current) {
      return;
    }
    const res = !isEmpty(tableSelectionNews)
      ? tableSelectionNews
      : tableSelectionAll;
    setUserIds((pre) => ({
      ...pre,
      addNumber: res?.length,
      userList: res?.map((item) => item?.id) || [],
    }));
    return res;
  }, [
    tableSelectionNews,
    tableSelectionAll,
    setUserIds,
    // dataTable,
    setTableSelection,
  ]);
  // TODO: 表格事件以及表格数据封装hooks，用在kol以及gameS页面
  // 表格排序事件
  const onTableSortChage = useMemoizedFn((e) => {
    if (isEmpty(e)) return;
    const { sortMetric, sortVal, ratioType } = e || {};
    const isRaido = ratioType === 0 ? sortMetric : `${sortMetric}_ratio`;
    sort.current.order_metric = sortMetric;
    sort.current.order = ratioType;
    setParamsDefault({
      ...kolRankListProps,
      order_metric: isRaido,
      order: sortVal,
    });
    const offType = isEmpty(tableSelectionNews) ? 'clearAll' : 'defauletAll';
    setOperatedGame(offType);
  });
  // 表格分页事件
  const onTablePagingChange = (e) => {
    const { pageIndex, pageSize } = e || {};
    ecahrtsIsRefresh.current = true;
    setKolRankListProps({
      ...kolRankListProps,
      page: pageIndex,
      page_size: pageSize,
    });
  };
  // 表格check多选事件
  const onTableCheckGame = <T extends unknown>(
    selectList: T[],
    type: string,
  ) => {
    const userList = selectList.map((item) => item?.id) || [];
    const mergeList = uniq(userList);
    setOperatedGame(type);
    if (type === 'cancel') {
      setTableSelection([]);
      setTableSelectionAll([]);
    } else if (type === 'all') {
      setTableSelection(tableSelectionAllOneRefs.current);
    } else {
      setTableSelection(selectList as never[]);
    }
    setUserIds((pre) => ({
      ...pre,
      addNumber: selectList.length || 6,
      userList: mergeList,
    }));
  };
  // 清空回调, 发现其他榜单规则和这个不一样,目前做的是多选、图表还原
  const handleClearSearch = useMemoizedFn(() => {
    // 图表还原
    ecahrtsIsRefresh.current = false;
    // 接口还原
    getDefauletStreamingList.current = 'defaulet';
    // 清空搜索值
    setParamsDefault({
      page: 1,
      page_size: 100,
    });
    setKolRankListProps({
      page: 1,
      page_size: 100,
      app_ids: [],
    });
    setUserIds((pre) => ({
      ...pre,
      addNumber: TOP_COMPANIES_NUM,
    }));
    // 勾选还原
    setTableSelection([]);
    setImgActive('');
    setOperatedGame('');
  });
  // 搜索结果格式化回调
  const transTableDataForSearch = useMemoizedFn((res: any) => {
    const resultList = res;
    if (!Array.isArray(resultList) || !resultList?.length) {
      return [];
    }
    return formattingGameSearchList(resultList);
  });
  // 下拉选择框搜索点击
  const getTableSearchList = useMemoizedFn(
    (id: string, values: { [key in string]: string }) => {
      ecahrtsIsRefresh.current = true;
      setImgActive(values.imgSrc);
      getDefauletStreamingList.current = 'gameSearchIng';
      setKolRankListProps({
        app_ids: [id],
        page: 1,
        page_size: 100,
      });
    },
  );
  // 搜索回调
  const getMetricsTableDataRankList = useMemoizedFn(
    ({ search_by_name }: { search_by_name: string; }, config) => {
      const timeDate = {
        end_date: data?.start_data_time,
        start_date: data?.end_data_time,
      };
      const params = {
        ...timeDate,
        ...kolRankListProps,
        ...paramsDefault,
        search_by_name,
        search_name: search_by_name,
      };
      return runAsync(params, config).then((res) => res);
    },
  );

  // 表格跳转
  // TODO: 有时间装个router依赖，当点击跳转其他页面，再回到本页面，缓存本页面数据，不在重新调一遍接口，
  const getDetailGamePath = (
    topPayload: ObjectOfStringValue,
    // type?: boolean,
  ) => {
    // 目前没有下拉内容跳转了，所以type没有意义了
    /** 【PC情报】【Funcom】 情报直播页面增加游戏类型筛选器，直播榜单页，多个icon都展示出来
     * 点击标题优先跳转顺序：Mobile-->PC-->Console； 去掉下拉的跳转
     */
    if (typeof topPayload !== 'object') {
      return '';
    }
    const keys = ['mobile', 'pc', 'console', 'combine'];
    const foundKey: string = keys.find((key) => key in topPayload) || '';

    const pathname = getDetailGamePathCommon({
      entityType: foundKey,
      gameId: topPayload[foundKey],
      tab: 'streaming',
      subTab,
    });
    return pathname;

    /** 下面type为true和为false是不一样的数据返回，
    let gameId = '';
    let entityType = '';
    if (type) {
      // eslint-disable-next-line prefer-destructuring
      entityType =
        (isPlainObject(topPayload) && Object.keys(topPayload)[0]) || '';
      // eslint-disable-next-line prefer-destructuring
      gameId =
        (isPlainObject(topPayload) && Object.values(topPayload)[0]) || '';
    } else {
      entityType = toLower(topPayload?.text);
      gameId = topPayload?.value;
    }
    const pathname = getDetailGamePathCommon({
      entityType,
      gameId,
      tab: 'streaming',
      subTab,
    });
    return pathname;
    */
  };

  const onTablGoToDetails = (
    topPayload: ObjectOfStringValue,
    // type?: boolean,
  ) => {
    history.push(getDetailGamePath(topPayload));
  };

  const selectedIds = useMemo(() => {
    const tableSelection = !isEmpty(tableSelectionNews)
      ? tableSelectionNews
      : tableSelectionAll;
    return tableSelection?.map((item: any) => item?.id) || [];
  }, [tableSelectionNews, tableSelectionAll]);


  const getCheckedLinesCfg = () => ({ key: 'select_ids', value: selectedIds });

  useEffect(() => {
    if (data) {
      // setParamsDefault({
      //   end_date: get(data, 'end_data_time', ''),
      //   start_date: get(data, 'start_data_time', '')
      // })
      setTimeConfig({
        end_date: get(data, 'end_data_time', ''),
        start_date: get(data, 'start_data_time', ''),
      });
    }
  }, [data]);
  // console.log(timeConfig)
  return (
    <>
      <Justify
        className="dbi-pcGame-jf pc-metricstable-jf dbi-card-justify"
        right={
          <>
            <SearchRecent
              resetSearchType={'steaming'}
              placeholder={formatMessage(
                { id: 'dbi_table_search_placeholder' },
                {
                  domainName: formatMessage({
                    id: 'dbi_game',
                  }),
                },
              )}
              fetchParams={{ ...paramsDefault, ...kolRankListProps }}
              handleClear={handleClearSearch}
              initSearchInput={true}
              // 表格id
              getTableResultList={getTableSearchList}
              // 搜索接口
              searchListApi={getMetricsTableDataRankList}
              // 格式化
              transTableDataForSearch={transTableDataForSearch}
            />
            <ExportTable
              classModalName=""
              entityType="streaming"
              // @ts-ignore
              businessType="streaming-games-top"
              downloadModalSize={820}
              isDisableDownload={tableLoading}
              downloadLogConfigKey="streamingGamesDownloadExcel"
              // excelName=""
              total={(data as any)?.total_games_data}
              isNeedCheckedLines={true}
              tableParams={{
                ...paramsDefault,
                ...kolRankListProps,
                select_ids: selectedIds,
                start_date:
                  paramsDefault?.start_date || data?.start_data_time || '',
                end_date: paramsDefault?.end_date || data?.end_data_time || '',
              }}
              getCheckedLinesCfg={getCheckedLinesCfg}
            />
          </>
        }
      />
      <div id="metrics-table-container">
        <CardSlot>
          <Tables
            {...{
              topChartsType: 'streaming_games_revenue',
              records: dataTable,
              loading: tableLoading,
              tableTotal: data?.total_games_data,
              tableSelection: !isEmpty(tableSelectionNews)
                ? tableSelectionNews
                : tableSelectionAll,
              imgActive,
              tableSelectionAll,
              pageSortAttr: {
                currentOrderSource: '',
                currentSortMetric: sort.current!.order_metric,
                currentRatioType: sort.current!.order,
                currentSortValue: paramsDefault?.order,
                tablePageIndex: kolRankListProps?.page,
                tablePageSize: kolRankListProps?.page_size || 100,
              },
              gameTypes: ['hoursWatched', 'peackCCV', 'avgCCV', 'airtime'],
              onTableSortChage,
              onTablePagingChange,
              onTableCheckGame,
              onTablGoToDetails,
              getDetailGamePath,
            }}
          />
        </CardSlot>
      </div>
    </>
  );
};

export default memo(StreamingGamesTableList);
